var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissingImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 481.1",
    style: {
      enableBackground: "new 0 0 700 481.1"
    },
    xmlSpace: "preserve",
    fil: "#000000",
    height: "48px",
    width: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.3,189.9c24.6,0,44.6-20,44.6-44.6c0-24.6-20-44.6-44.6-44.6s-44.6,20-44.6,44.6 C321.7,169.8,341.7,189.9,366.3,189.9z M366.3,112.8c17.9,0,32.4,14.6,32.4,32.4s-14.6,32.4-32.4,32.4s-32.4-14.6-32.4-32.4 S348.4,112.8,366.3,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M700,481.1l-93.7-154.5V55.1c0-30.4-24.7-55.1-55.1-55.1H55.1C24.7,0,0,24.7,0,55.1v327.6 c0,30.4,24.7,55.1,55.1,55.1h384l-25.6,43.4H700z M434.9,468.9l120.1-203.5l123.4,203.5H434.9z M55.1,12.2h496.2 c23.6,0,42.9,19.2,42.9,42.9v251.5l-39.4-64.9l-15.1,25.6l-71-56.2l-118.1,96.6L204.9,149.4L12.2,318.9V55.1 C12.2,31.4,31.4,12.2,55.1,12.2z M55.1,425.5c-23.6,0-42.9-19.2-42.9-42.9v-47.5L204,166.5l145.4,157.9l119.4-97.7l64.6,51.1 l-87.1,147.7H55.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.8,
    y: 435.4,
    className: "st0",
    width: 13.7,
    height: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.7,
    y: 312.3,
    className: "st0",
    width: 12.1,
    height: 106.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingImage);
export default __webpack_public_path__ + "static/media/missing_image.24743c9bddf142c6f21b0a8e933ef7c4.svg";
export { ForwardRef as ReactComponent };